module.exports = __webpack_public_path__ + "img/9H.33ab7891.png";